import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import { FavoritesProvider } from "./context/FavoritesContext";
import { SearchProvider } from "./context/SearchContext";
import App from "./App";
// Inicializa i18next ANTES de renderizar React. Calquera compoñente que
// use t() ou <Trans> require que i18n estea iniciado. Ver docs/I18N_PLAN.md.
import "./i18n";
import Spinner from "./components/ui/Spinner";
import "./index.css";

// X-3.4 · Sentry para tracking de erros en produción.
// DSN inxéctase no build via VITE_SENTRY_DSN. Sen DSN, init é no-op.
if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
    tracesSampleRate: 0.1,
    // BrowserTracing automático: pista navegacións + fetch/xhr.
    // Sen integrations explícitas, Sentry usa as por defecto.
  });
}

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Suspense
      fallback={
        <div className="flex items-center justify-center min-h-screen">
          <Spinner />
        </div>
      }
    >
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <FavoritesProvider>
              <SearchProvider>
                <App />
              </SearchProvider>
            </FavoritesProvider>
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </Suspense>
  </StrictMode>
);
